import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/address-book': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M436 160C442.6 160 448 154.6 448 148V108C448 101.4 442.6 96 436 96H416V48C416 21.5 394.5 0 368 0H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H368C394.5 512 416 490.5 416 464V416H436C442.6 416 448 410.6 448 404V364C448 357.4 442.6 352 436 352H416V288H436C442.6 288 448 282.6 448 276V236C448 229.4 442.6 224 436 224H416V160H436zM368 464H48V48H368V464zM208 256C243.3 256 272 227.3 272 192S243.3 128 208 128 144 156.7 144 192 172.7 256 208 256zM118.4 384H297.6C310 384 320 375.4 320 364.8V345.6C320 313.8 289.9 288 252.8 288 242 288 234.1 296 208 296 181.1 296 174.6 288 163.2 288 126.1 288 96 313.8 96 345.6V364.8C96 375.4 106 384 118.4 384z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/address-book.js
// module id = Embg
// module chunks = 144